import SaleShell, { MegaSaleLayoutProps } from '@v2/shared/Layouts/MegaSale/SaleShell';

import Footer from '../Full/Footer';
import Navigation from './Navigation/Navigation';

export type { MegaSaleLayoutProps };

/**
 * The chrome of a DiscountMags sale page.
 *
 * `SaleShell` — the providers, the cart drawer and the floor under the content, which
 * every brand's sale shares — with this brand's own header and footer in its two slots.
 *
 * The header is why this brand does not resolve to `shared/Layouts/MegaSale` the way
 * MagSpot, MagZoom and TopMags do. DiscountMags' is Full's header with the categories
 * taken out: fixed rather than in normal flow, so it measures its own height and reserves
 * it with a spacer, and it carries the account slide-over, the support popover and the
 * mobile search toggle that the other three brands' headers have no counterpart for. The
 * page's sticky category headings clear it through `--sale-header-height`, which only a
 * measured header can publish. Reconciling the two would mean a prop for nearly every
 * line — the same conclusion `shared/Layouts/Full/TwoStripNavigation` reached about this
 * brand's site header.
 */
export default function MegaSale({ children, ...shellProps }: MegaSaleLayoutProps) {
  return (
    <SaleShell
      {...shellProps}
      navigation={(searchProps) => <Navigation searchProps={searchProps} />}
      footer={<Footer />}
    >
      {children}
    </SaleShell>
  );
}
